import { forwardRef } from 'react';
import { Input as ChakraInput, FormLabel, FormControl, FormErrorMessage } from '@chakra-ui/react';

const Input = ({ label, type, ...rest }, ref) => {
  if (label) {
    return (
      <FormControl isInvalid={!!rest.error}>
        <FormLabel fontSize="13px">{label}</FormLabel>
        <ChakraInput name={rest.name} type={type} ref={ref} {...rest} />
        <FormErrorMessage fontSize="11px" fontWeight="normal" fontStyle="italic">
          {rest.error && rest.error.message}
        </FormErrorMessage>
      </FormControl>
    );
  }

  return <ChakraInput name={rest.name} type={type} ref={ref} {...rest} />;
};

export default forwardRef(Input);
